import React, { Component } from "react";
import { Navigate } from "react-router-dom";

// Base Ui
import UiAlerts from "../pages/BaseUi/UiAlerts/UiAlerts";
import UiBadges from "../pages/BaseUi/UiBadges/UiBadges";
import UiButtons from "../pages/BaseUi/UiButtons/UiButtons";
import UiColors from "../pages/BaseUi/UiColors/UiColors";
import UiCards from "../pages/BaseUi/UiCards/UiCards";
import UiCarousel from "../pages/BaseUi/UiCarousel/UiCarousel";
import UiDropdowns from "../pages/BaseUi/UiDropdowns/UiDropdowns";
import UiGrid from "../pages/BaseUi/UiGrid/UiGrid";
import UiImages from "../pages/BaseUi/UiImages/UiImages";
import UiTabs from "../pages/BaseUi/UiTabs/UiTabs";
import UiAccordions from "../pages/BaseUi/UiAccordion&Collapse/UiAccordion&Collapse";
import UiModals from "../pages/BaseUi/UiModals/UiModals";
import UiOffcanvas from "../pages/BaseUi/UiOffcanvas/UiOffcanvas";
import UiPlaceholders from "../pages/BaseUi/UiPlaceholders/UiPlaceholders";
import UiProgress from "../pages/BaseUi/UiProgress/UiProgress";
import UiNotifications from "../pages/BaseUi/UiNotifications/UiNotifications";
import UiMediaobject from "../pages/BaseUi/UiMediaobject/UiMediaobject";
import UiEmbedVideo from "../pages/BaseUi/UiEmbedVideo/UiEmbedVideo";
import UiTypography from "../pages/BaseUi/UiTypography/UiTypography";
import UiList from "../pages/BaseUi/UiLists/UiLists";
import UiGeneral from "../pages/BaseUi/UiGeneral/UiGeneral";
import UiRibbons from "../pages/BaseUi/UiRibbons/UiRibbons";
import UiUtilities from "../pages/BaseUi/UiUtilities/UiUtilities";

// Advance Ui
import UiNestableList from "../pages/AdvanceUi/UiNestableList/UiNestableList";
import UiScrollbar from "../pages/AdvanceUi/UiScrollbar/UiScrollbar";
import UiAnimation from "../pages/AdvanceUi/UiAnimation/UiAnimation";
import UiSwiperSlider from "../pages/AdvanceUi/UiSwiperSlider/UiSwiperSlider";
import UiRatings from "../pages/AdvanceUi/UiRatings/UiRatings";
import UiHighlight from "../pages/AdvanceUi/UiHighlight/UiHighlight";

// Widgets
// import Widgets from '../pages/Widgets/Index';

import FileUpload from "../pages/Forms/FileUpload/FileUpload";

//Tables
import BasicTables from "../pages/Tables/BasicTables/BasicTables";
import ListTables from "../pages/Tables/ListTables/ListTables";
import ReactTable from "../pages/Tables/ReactTables";

//Icon pages
import RemixIcons from "../pages/Icons/RemixIcons/RemixIcons";
import BoxIcons from "../pages/Icons/BoxIcons/BoxIcons";
import MaterialDesign from "../pages/Icons/MaterialDesign/MaterialDesign";
import FeatherIcons from "../pages/Icons/FeatherIcons/FeatherIcons";
import LineAwesomeIcons from "../pages/Icons/LineAwesomeIcons/LineAwesomeIcons";
import CryptoIcons from "../pages/Icons/CryptoIcons/CryptoIcons";

//Maps

//APi Key

//login
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";

// User Profile
import UserProfile from "../pages/Authentication/user-profile";
import UiLink from "../pages/BaseUi/UiLinks/UiLinks";
import UserList from "../pages/User/UserList";
import UserDetails from "../pages/User/UserDetails";
import MealCategoryList from "../pages/MealCategory/MealCategoryList";
import Dashboard from "../pages/Dashboard/Dashboard";
import ChangePassword from "../pages/Authentication/ChangePassword";
import ErrorPage from "../pages/ErrorPage/ErrorPage";
import OfflinePage from "../pages/ErrorPage/OfflinePage";
import NotFound from "../pages/ErrorPage/NotFound";
import TaxMaster from "../pages/Master/TaxMaster/TaxMaster";
import Customer from "../pages/Master/Customers/Customers";
import GLgroup from "../pages/Master/GLgroup/GLgroup";
import GeneralLedger from "../pages/Master/GeneralLedger/GeneralLedger";
import SubLedgerBalance from "../pages/Master/SubLedger/SubLedgerBalance";
import LedgerOpeningBalance from "../pages/Master/LedgerOpeningBalance/LedgerOpeningBalance";
import AccountSetting from "../pages/Master/AccountSetting/AccountSetting";
import PartyMaster from "../pages/Master/Supplier/Supplier";
import VehicalMaster from "../pages/Master/VehicalMaster/VehicalMaster";
import BookTrip from "../pages/Transactions/BookTrip/BookTrip";
import SalesInvoiceGST from "../pages/Transactions/SalesInvoice/SalesInvoiceGST";
import InvoiceCharges from "../pages/Transactions/InvoiceCharges/InvoiceCharges";
import TransactionsAccount from "../pages/Transactions/TransactionAccount/TransactionsAccount";
import ReportAccounts from "../pages/Reports/ReportsAccount/ReportAccounts";
import Gst from "../pages/Reports/GST/Gst";
import SalesInvoice from "../pages/Reports/SalesInvoice/SalesInvoiceRegister";
import SalesInvoiceRegister from "../pages/Reports/SalesInvoice/SalesInvoiceRegister";
import TripSheet from "../pages/Reports/TripSheet/TripSheet";
import OtherCharges from "../pages/Reports/OtherCharges/OtherCharges";
import Session from "../pages/Master/Session/Session";
import InvoiceChargesList from "../pages/Transactions/InvoiceCharges/InvoiceCharges";
import ReportLedger from "../pages/Ledger/ReportLedger";
import ExcelUpload from "../pages/SupplierExcel/SupplierExcel";

const authProtectedRoutes = [
  //user
  { path: "/userlist", component: <UserList /> },
  { path: "/userDetails/:id", component: <UserDetails /> },

  { path: "/mealCategoryList", component: <MealCategoryList /> },

  { path: "/taskMaster", component: <TaxMaster /> },
  { path: "/session", component: <Session /> },
  { path: "/customers", component: <Customer /> },
  { path: "/glGroup", component: <GLgroup /> },
  { path: "/generalLedger", component: <GeneralLedger /> },
  { path: "/subLadgerBalance", component: <SubLedgerBalance /> },
  { path: "/ledgerOpeningBalance", component: <LedgerOpeningBalance /> },
  { path: "/accountSetting", component: <AccountSetting /> },
  { path: "/partyMaster", component: <PartyMaster /> },
  { path: "/vehicalMaster", component: <VehicalMaster /> },
  { path: "/bookTrip", component: <BookTrip /> },
  { path: "/salesInvoiceGST", component: <SalesInvoiceGST /> },
  { path: "/invoiceCharges", component: <InvoiceChargesList /> },
  { path: "/transactionAccount", component: <TransactionsAccount /> },
  { path: "/reportAccount", component: <ReportAccounts /> },
  { path: "/salesInvoice", component: <SalesInvoiceRegister /> },
  { path: "/gst", component: <Gst /> },
  { path: "/tripSheet", component: <TripSheet /> },
  { path: "/otherCharges", component: <OtherCharges /> },
  { path: "/ledger", component: <ReportLedger /> },
  { path: "/excelUpload", component: <ExcelUpload /> },

  // Base Ui
  { path: "/ui-alerts", component: <UiAlerts /> },
  { path: "/ui-badges", component: <UiBadges /> },
  { path: "/ui-buttons", component: <UiButtons /> },
  { path: "/ui-colors", component: <UiColors /> },
  { path: "/ui-cards", component: <UiCards /> },
  { path: "/ui-carousel", component: <UiCarousel /> },
  { path: "/ui-dropdowns", component: <UiDropdowns /> },
  { path: "/ui-grid", component: <UiGrid /> },
  { path: "/ui-images", component: <UiImages /> },
  { path: "/ui-tabs", component: <UiTabs /> },
  { path: "/ui-accordions", component: <UiAccordions /> },
  { path: "/ui-modals", component: <UiModals /> },
  { path: "/ui-offcanvas", component: <UiOffcanvas /> },
  { path: "/ui-placeholders", component: <UiPlaceholders /> },
  { path: "/ui-progress", component: <UiProgress /> },
  { path: "/ui-media", component: <UiMediaobject /> },
  { path: "/ui-embed-video", component: <UiEmbedVideo /> },
  { path: "/ui-typography", component: <UiTypography /> },
  { path: "/ui-lists", component: <UiList /> },
  { path: "/ui-links", component: <UiLink /> },
  { path: "/ui-general", component: <UiGeneral /> },
  { path: "/ui-ribbons", component: <UiRibbons /> },
  { path: "/ui-utilities", component: <UiUtilities /> },

  // Advance Ui
  { path: "/advance-ui-nestable", component: <UiNestableList /> },
  { path: "/advance-ui-scrollbar", component: <UiScrollbar /> },
  { path: "/advance-ui-animation", component: <UiAnimation /> },
  { path: "/advance-ui-swiper", component: <UiSwiperSlider /> },
  { path: "/advance-ui-ratings", component: <UiRatings /> },
  { path: "/advance-ui-highlight", component: <UiHighlight /> },

  // Widgets
  // { path: "/widgets", component: <Widgets /> },

  { path: "/forms-file-uploads", component: <FileUpload /> },

  //Tables
  { path: "/tables-basic", component: <BasicTables /> },
  { path: "/tables-listjs", component: <ListTables /> },
  { path: "/tables-react", component: <ReactTable /> },

  //Icons
  { path: "/icons-remix", component: <RemixIcons /> },
  { path: "/icons-boxicons", component: <BoxIcons /> },
  { path: "/icons-materialdesign", component: <MaterialDesign /> },
  { path: "/icons-feather", component: <FeatherIcons /> },
  { path: "/icons-lineawesome", component: <LineAwesomeIcons /> },
  { path: "/icons-crypto", component: <CryptoIcons /> },

  { path: "/profile", component: <UserProfile /> },

  { path: "/dashboard", component: <Dashboard /> },
  { path: "/reset-password", component: <ChangePassword /> },

  // { path: "/pages-profile", component: <SimplePage /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/not-found" /> },
];

//this is the end point of the protec

const publicRoutes = [
  // Authentication Page

  //user profile

  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/register", component: <Register /> },
  { path: "/server-error", component: <ErrorPage /> },
  { path: "/offline", component: <OfflinePage /> },
  { path: "/not-found", component: <NotFound /> },
];

export { authProtectedRoutes, publicRoutes };
